import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthProvider";
import LoadingAnimation from "./Assets/LoadingAnimation.gif"

const PrivateRoute = ({ element }) => {
  const { authenticated } = useContext(AuthContext);

  if (authenticated === null) {
    return <div style={{width:"100vw", height:"100vh",background:"rgba(0, 0, 0, 0.4)",display:'flex',justifyContent:'center',alignItems:"center"}}><img src={LoadingAnimation} alt="" /></div>;
  }

  return authenticated ? element : <Navigate to="/sign-in" />;
};

export default PrivateRoute;
